// extracted by mini-css-extract-plugin
export default {"b-icon-warning":"Checkbox_style_b-icon-warning__5Dme0","checkbox":"Checkbox_style_checkbox__nsQ5I","rotate":"Checkbox_style_rotate__ArSPy"};